import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import stepbtn from "../Skills/images/step_btn.svg";
import { baseURL } from "../../config";

const PrimaryCategoryTable = () => {
  const [posts, setPosts] = useState({ categories: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedcategories, setEditedCategories] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getcategories`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.categories)) {
          setPosts({ categories: data.categories });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (categoryId) => {
    try {
      setCategoryToDelete(categoryId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deletecategory?id=${categoryToDelete}`
      );
      const updatedCategories = posts.categories.filter(
        (category) => category.id !== categoryToDelete
      );
      setPosts({ categories: updatedCategories });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleSaveEditedCategory = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/categoryupdate?id=${editedcategories.id}`,
        editedcategories
      );
      console.log("Updated Category:", response.data);
      // Update the state with the updated grade
      const updatedCategory = posts.categories.map((categories) => {
        if (categories.id === editedcategories.id) {
          return editedcategories;
        }
        return categories;
      });
      setPosts({ categories: updatedCategory });
      setShowEditModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Category not found. Please try again.");
      } else {
        console.error("Error updating Grade:", error);
      }
    }
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.categories.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    //TODO update
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (categories) => {
    setEditedCategories(categories);
    setShowEditModal(true);
  };

  const onRowClick = (tempid) => {
    window.location = "/subcategorymain?id=" + tempid;
  };

  // Define handleSaveEditedSmartGoal function
  const handleSaveEditedCategories = () => {
    // Logic to save the edited smart goal

    setShowEditModal(false);
  };

  const showCategory = () => {};

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Category List</h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a
            href="/primarycategoryform"
            className="text-decoration-none text-white"
          >
            <button type="button" class="btn btn-danger rounded-pill">
              Add Category +
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Category Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((categories, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{categories.categoryname}</td>

              {/* Action buttons */}
              <td className="text-center">
                <ReactBootstrap.Button
                  onClick={() => onRowClick(categories.id)}
                  className="bg-transparent border-0"
                >
                  <img src={stepbtn}></img>
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(categories)}
                >
                  <img src={Editbtn}></img>
                </ReactBootstrap.Button>
                {/* <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => handleDelete(categories.id)}
                >
                  <img src={deletebtn}></img>
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Delete confirmation modal */}
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          <p className="text-danger fw-bold">
            Are you sure you want to delete this Category?
          </p>
          Deleting Category will also impact the Grade based templates.
          <b>
            If there are no templates forthis Category you can delete safely.
          </b>
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {/* Edit Modal */}
      {showEditModal && editedcategories && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Category</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>category Name :</label>
              <input
                type="text"
                value={editedcategories.categoryname}
                onChange={(e) =>
                  setEditedCategories({
                    ...editedcategories,
                    categoryname: e.target.value,
                  })
                }
              />
            </div>

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedCategory}
            >
              Update
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.categories.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default PrimaryCategoryTable;
